module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"America Prays","short_name":"America Prays","start_url":"/","background_color":"#0b0c0d","theme_color":"#0b0c0d","display":"standalone","icon":"src/images/favicon.png","include_favicon":false,"theme_color_in_head":false,"crossOrigin":"use-credentials","legacy":true,"cache_busting_mode":"query","cacheDigest":"fa678848dd503c2324002a6bd5352074"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
